<div class="modal-header">
  <h4 class="modal-title">Edit item {{ itemModel?.itemId }} ({{ itemModel?.description }}, {{ itemModel?.detailedDescription }})</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  @if (loading) {
    <div class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  @if (!loading) {
    <form #supplierForm="ngForm">
      <!-- Main Supplier -->
      <div class="form-group row mb-3">
        <label for="mainSupplier" class="col-sm-3 col-form-label"><b>Is main supplier</b></label>
        <div class="col-sm-9">
          <select dropdown class="form-select form-select-sm control-label" id="mainSupplier" name="mainSupplier" [(ngModel)]="selectedMainSupplierId" [required]="suppliers.length > 0">
            <option value="">Select main supplier...</option>
            @for (supplier of suppliers; track supplier) {
              <option [value]="supplier.supplierDetails.supplierId">
                {{ getSupplierDisplayName(supplier) }}
              </option>
            }
          </select>
        </div>
      </div>
      
      <!-- Core Item Owner -->
      <div class="form-group row mb-3">
        <label for="coreItemOwner" class="col-sm-3 col-form-label"><b>Is core item owner</b></label>
        <div class="col-sm-9">
          <select dropdown class="form-select form-select-sm control-label" id="coreItemOwner" name="coreItemOwner" [(ngModel)]="selectedCoreItemOwnerId">
            <option value="">Select core item owner...</option>
            @for (supplier of suppliers; track supplier) {
              <option [value]="supplier.supplierDetails.supplierId">
                {{ getSupplierDisplayName(supplier) }}
              </option>
            }
          </select>
        </div>
      </div>

      <!-- Item State -->
      <div class="form-group row mb-3">
        <label for="itemState" class="col-sm-3 col-form-label"><b>Item state</b></label>
        <div class="col-sm-9">
          <select class="form-select form-select-sm" id="itemState" name="itemState" [(ngModel)]="selectedItemState" required>
            @for (option of availableItemStateOptions; track option.value) {
              <option [value]="option.value">{{ option.value }} ({{ option.text }})</option>
            }
          </select>
          @if (!isActiveStateValid) {
            <div class="text-danger small mt-1">
              Cannot set to ACTIVE: item requires a non-empty AlsisProductCode and at least one supplier
              with a valid StockCode (not NA), a CountryOfOriginCode, and NetWeight &gt; 0
              (NetWeight not required when StockCode is RI).
            </div>
          }
        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-outline-dark" (click)="save()" [disabled]="!supplierForm?.form.valid || loading || !isActiveStateValid || (suppliers.length === 0 && selectedItemState === originalItemState)">Save</button>
</div>
